import React, {useEffect, useState} from 'react';
import './Portfolio.css';
import IMG1 from '../../assets/gym-website.png';
import IMG2 from '../../assets/kwese.png';
import IMG3 from '../../assets/Music-App.png';
import IMG4 from '../../assets/port-web.png';
import IMG5 from '../../assets/portfolio5.png';
import IMG6 from '../../assets/gym-website.png';
import Aos from 'aos';
import "aos/dist/aos.css";
import { motion, AnimatePresence } from 'framer-motion';
import { FiExternalLink } from 'react-icons/fi';
import { FaBehance } from 'react-icons/fa';
import { FiGithub } from 'react-icons/fi';

const data = [
  {
    id: 1,
    image: IMG1,
    category: "Web",
    title: 'A gym website designed using React JS',
    link: "https://github.com/eltonalexanderajadi/react-gym-website",
    site:  <FiGithub />,
    demo: "https://eltonalexanderajadi.github.io/react-gym-website/"
  },
  {
    id: 2,
    image: IMG2,
    category: "Web",
    title: 'kweseinfo news website',
    link: "https://github.com",
    site: <FiGithub />,
    demo: "https://kweseinfo.com"
  },
  {
    id: 3,
    image: IMG3,
    category: "UI/UX",
    title: 'A Music-App UI Design',
    link: "https://www.behance.net/eltonajadi",
    site: <FaBehance />,
    demo: "https://www.behance.net/gallery/152610665/Music-App-UI-Design"
  },
  {
    id: 4,
    image: IMG4,
    category: "Web",
    title: 'My Portfolio website',
    link: "https://github.com/eltonalexanderajadi/react-portfolio-prototype-website",
    site: <FiGithub />,
    demo: "https://eltonalexander.vercel.app"
  },
  {
    id: 5,
    image: IMG6,
    category: "UI/UX",
    title: 'UI Design of the Gym Website',
    link: "https://behance.com",
    site:  <FaBehance />,
    demo: "https://behance.com"
  }
  
]



const Portfolio = () => {
  useEffect(() => {
    Aos.init({duration: 1000});
  },[]);

  const [state, setState] = useState(data);
 
  const handleBtns=(e) => {
  
    let word=e.target.value;
  
    if(word === 'All'){
      setState(data)
    }
    else if(word === 'Web'){
      const filtered = data.filter(item=>item.category==="Web");

      setState(filtered);
    }
    else if(word === 'UI/UX'){
      const filtered = data.filter(item=>item.category==="UI/UX");

      setState(filtered);
    }
    }
  

  

  return (
    <section id="portfolio"> 
        <h5 data-aos="fade-in"> My Recent Works </h5>
        <h2 data-aos="fade-in"> Portfolio </h2>
        <div className='button__containers'>
        <button  value="All" onClick={handleBtns} className={state === 'All' ? 'active' : ''} > All </button>
        <button  value="Web" onClick={handleBtns} className={state === 'Web' ? 'active' : ''}> Web Projects </button>
        <button  value="UI/UX" onClick={handleBtns} className={state === 'UI/UX' ? 'active' : ''}> UI/UX Designs </button>
        </div>

        <div className='container portfolio__container'>
          {
            state.map((item) => {
              return (
                <motion.article layout animate={{ opacity: 1}} initial={{opacity: 0}} exit={{opacity: 0}} key={item.id} className='portfolio__item' data-aos="zoom-in">
                  <AnimatePresence>
                <div className='portfolio__item-image'>
                  <img src={item.image} alt={item.title} />
                </div>
                  <h3> {item.title} </h3>
                <div className='portfolio__item-cta'>
                  <a href={item.link}  className='portfolio-link' target='_blank'> {item.site}</a>
                  <a href={item.demo}  className='portfolio-link' target='_blank'> <FiExternalLink /> </a>
                </div>
                </AnimatePresence>
                </motion.article>
              )
            })
          }
        </div>
    </section>
  )
}

export default Portfolio